import { createApiMutationHook, type IApiMutationFunction } from "../../utils/api";

export type INotificationMarkAllAsReadResult = {
    read: number;
};

export const notificationMarkAllAsReadMutation: IApiMutationFunction<void> = () => ({
    baseURL: "",
    method: "POST",
    url: "/api/notifications/read-all",
});

// Internal Next route until the API exposes a bulk read operation
export const useNotificationMarkAllAsReadMutation = createApiMutationHook<void, INotificationMarkAllAsReadResult>(
    notificationMarkAllAsReadMutation,
);
